module.exports = __webpack_public_path__ + "static/media/platform_windows.a852a087.png";